module.exports = __webpack_public_path__ + "img/exam.9a6ef1b8.svg";